import cookieCategories from './cookies.yml';

/* eslint-disable max-statements */

/* eslint-disable */
/*
 * This module is absorbing the BBC cookies API as per ORBITEN-361. The reasoning behind this architecture can be found here:
 * https://github.com/bbc/cd-docs/blob/master/navigation/webmodules/cookie-banner/x-domain-cookies-tech-approaches.md
 *
 */

  /**
   * Cookies module.
   * @module orb/cookies
   */

  const bbccookies = {};
  var onHttps = document.location.protocol === 'https:';

  bbccookies.IMPLICIT_FLAG = '0';
  bbccookies.EXPLICIT_FLAG = '1';
  bbccookies.EXPLICIT_FLAG_EU = '2';
  bbccookies.POLICY_REFRESH_DATE_MILLIS = new Date(2015, 4, 21, 0, 0, 0, 0).getTime();
  bbccookies.PRIVACY_COOKIE_NAME = 'ckns_privacy';
  bbccookies.EXPLICIT_COOKIE_NAME = 'ckns_explicit';
  bbccookies.POLICY_COOKIE_NAME = 'ckns_policy';
  bbccookies.CURRENT_PRIVACY_POLICY = 'july2019';

  const cookieOvenEndpointMap = {
    'www.int.bbc.co.uk':
      'https://www.test.bbc.co.uk/cookieoven',
    'www.int.bbc.com':
      'https://www.int.bbc.com/cookieoven',
    'www.test.bbc.co.uk':
      'https://www.test.bbc.co.uk/cookieoven',
    'www.test.bbc.com':
      'https://www.test.bbc.com/cookieoven',
    'navigation.int.api.bbc.co.uk':
      'https://www.test.bbc.co.uk/cookieoven',
    'navigation.test.api.bbc.co.uk':
      'https://www.test.bbc.co.uk/cookieoven',
    'navigation.int.api.bbc.com':
      'https://www.test.bbc.com/cookieoven',
    'navigation.test.api.bbc.com':
      'https://www.test.bbc.com/cookieoven',
    'cookies.test.api.bbc.co.uk':
      'https://www.test.bbc.co.uk/cookieoven',
     /* //commented this out so webpack strips it out, bring it back in to change this behaviour
    'local.dev.bbc.co.uk:8080':   //cookies webmodule locally
      'http://local.dev.bbc.co.uk:8080/cookieoven',
    'local.dev.bbc.co.uk:7443':   //cookies webmodule locally over HTTPS
      'https://local.dev.bbc.co.uk:7443/cookieoven',
    'local.dev.bbc.co.uk:5000':   //Orbit locally
      'https://www.test.bbc.co.uk/cookieoven',
    'local.dev.bbc.com:8080':   //cookies webmodule locally
      'http://local.dev.bbc.com:8080/cookieoven',
    'local.dev.bbc.com:7443':   //cookies webmodule locally over HTTPS
      'https://local.dev.bbc.com:7443/cookieoven',
    'local.dev.bbc.com:5000':   //Orbit locally
      'https://www.test.bbc.com/cookieoven',
    */
  };

  var POLICY_EXPIRY_COOKIENAME = 'ckns_policy_exp';
  var GDPR_COUNTRIES = ['AT', 'AX', 'BE', 'BG', 'BL', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'EU', 'FI', 'FR', 'GB', 'GF', 'GG', 'GI', 'GP', 'GR', 'HR', 'HU', 'IE', 'IM', 'IS', 'IT', 'JE', 'LI', 'LT', 'LU', 'LV', 'MF', 'MT', 'MQ', 'NL', 'NO', 'PL', 'PM', 'PT', 'RE', 'RO', 'SE', 'SI', 'SK', 'YT'];
  var DEFAULTPOLICY = {
      ads: false,
      personalisation: false,
      performance: false,
      necessary: true
    },
    policyCache = {},

    /*
     * This object is the global whitelist which the 'cookie crunch' uses to decide
     * what cookies are allowed to remain on the page. We welcome PRs, but before
     * modifying these lists, please seek data protection advice from the Privacy
     * team via operationalprivacy@bbc.co.uk
     */
    bbccookies_jars = {};

  for (const category of Object.keys(cookieCategories)) {
    const cookieMatchers = cookieCategories[category].map(c => c.pattern);
    bbccookies_jars[category] = cookieMatchers.join('|');
  }

  bbccookies.isEU = function(countryCode) {
    return countryCode ? GDPR_COUNTRIES.indexOf(countryCode.toUpperCase()) !== -1 : false;
  }

  bbccookies.cookieOvenRequest = function(xhr, url, done) {
    // make an xhr request to the cookieOvenUrl
    try {
      xhr.open('GET', url, true);
      xhr.send();
    } catch (error) {
      if(done){
        done(error); //edge case not handled by XMLHttpRequest
      }
    }
  };

  function cookieOvenUrl(tld, name, value) {
    return window.orbitData.partialCookieOvenUrl + '.' + tld + '/' + name + '/' + value;
  }

  function handleCookieOvenError(msg, done) {
    if (done) {
      done(new Error(msg));
    }
  }

  function setupCookieOvenXHR(done){
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.onload = function() {
      if (done) {
        done(null, xhr.status);
      }
    };
    xhr.onerror = function(error) {
      handleCookieOvenError('Request to cross domain cookie service encountered an error with code' + xhr.status + '. ' + error, done);
    };
    xhr.onabort = function() {
      handleCookieOvenError('Request to cross domain cookie service was aborted.', done);
    };
    xhr.ontimeout = function() {
      handleCookieOvenError('Request to cross domain cookie service timed out.', done);
    };
    return xhr;
  }

  function domainSwitcher(domain){
    var domainFlipper = {
      'com': 'co.uk',
      'co.uk': 'com'
    };
    var tld = domain.match(/(co.uk|com)/)[0];
    return domainFlipper[tld];
  }

  bbccookies.cookieOvenClient = function(name, value, currentDomain, done) {

    // only try this if we have an environment that supports XHR properly
    if ('withCredentials' in new XMLHttpRequest()) {
      var allowedXDomainCookieNames = [bbccookies.POLICY_COOKIE_NAME, bbccookies.EXPLICIT_COOKIE_NAME];
      try {
        if (!currentDomain) {
          throw new Error('Cannot make request to cross domain cookie service when domain is not set.');
        }
        if (allowedXDomainCookieNames.indexOf(name) <= -1) {
          throw new Error('Cookie name is not in the whitelist accepted by the cross domain cookie service.');
        }

        var otherTld = domainSwitcher(currentDomain);
        var xhr = setupCookieOvenXHR(done);
        var url = cookieOvenUrl(otherTld, name, value);
        bbccookies.cookieOvenRequest(xhr, url, done);

      } catch (error) {
        if (done) {
          done(error);
        }
      }
    } else {
      done(new Error('Cannot make request to cross domain cookie service as this browser does not support XmlHttpRequest with credentials.'));
    }
  };

  /**
   *  Sets a specified cookie to a value, with optional options
   *  @public
   *  @param {string} name - The name of the cookie to be set. When second argument (value) is not set, this parameter
   *  can be used to set the cookie using a raw cookie string
   *  @param {string} [value] - The value the cookie will be set to.
   *  @param {object} [options] - Security (domain/path/secure) options and setting expiry time
   *  @param {date} [options.expiry = End Of Session] - The date on which the cookie will be removed by the browser
   *  @param {boolean} [options.secure] - If true, the cookie will be transmitted only over secure protocol as https
   *  @param {string} [options.domain = Host of current document] - The domain from which the cookie will be readable.
   *  E.g., "example.com",".example.com" (includes all subdomains) or "subdomain.example.com"; if not specified,
   *  defaults to the host portion of the current document location.
   *  @param {string} [options.path = current path of current document] - The path from which the cookie will be readable.
   * */
  bbccookies.set = function(name, value, options, done) {
    var cookieName, cookieString;
    if (value !== undefined) {
      // We're being used in key-value mode
      cookieName = sanitiseKey(name);
      cookieString = generateCookieString(cookieName, value, options);
      var crossDomainEnabled = options && options.crossDomainEnabled;
      if (bbccookies.isAllowed(cookieName) && crossDomainEnabled) {
        bbccookies.cookieOvenClient(name, value, options.domain, done);
      }
    } else {
      // We've been given a full cookie string ready to set
      cookieName = getCookieName(name);
      cookieString = name;
    }

    if (bbccookies.isAllowed(cookieName)) {
      document.cookie = cookieString;
    }
  };

  /**
   * @public
   * @param host - usually just pass in window.location.host but can be overriden for more control
   * @returns {string} - the endpoint to hit for cookie-oven functionality, defaults to live if no host given
   */
  function getServersideCookieURL(host) {
    return cookieOvenEndpointMap[host] || `https://www.${bbccookies._getCurrentDomain()}/cookieoven`;
  }

  /**
   * Sets the policy cookie serverside, also sets explicit since to set the policy you must have explicitly clicked something
   * @param {object} policy with the attributes ads, personalisation and performance
   * @param {string} region the region that the user is in. acceptable values are "gb" or "eu",
   * if anything else is given gb will be assumed
   * @returns {Promise<Response>}
   */
  bbccookies.setPolicy = function(policy){

    const policyString = '?policy=' + (policy.ads ? 1 : 0) + (policy.personalisation ? 1 : 0) + (policy.performance ? 1 : 0);
    const serversideCookieURL = getServersideCookieURL(window.location.host);

    //this domain
    fetch(`${serversideCookieURL}${policyString}`, { credentials: 'include' })

    // other domain
    let otherDomainServersideCookieURL
    let currentDomain = bbccookies._getCurrentDomain()
      .match(/(bbc.co.uk|bbc.com)/)[0]
    if (currentDomain === "bbc.co.uk") {
      otherDomainServersideCookieURL = serversideCookieURL.replace(".bbc.co.uk", ".bbc.com")
    } else {
      otherDomainServersideCookieURL = serversideCookieURL.replace(".bbc.com", ".bbc.co.uk")
    }
    return fetch(`${otherDomainServersideCookieURL}${policyString}`, { credentials: 'include' })
  }

  /**
   * Checks to see if the specified cookie name is allowed under the current browser/user's preferences.
   * @param {string} cookieName - The name of the cookie
   * @returns {boolean} True if a cookie with this name can be set under the current preferences
   */
  bbccookies.isAllowed = function(cookieName) {
    var policy,
      list,
      allowed;

    if (cookieName && cookieName.match && cookieName.match(/^ckns_cookietest[0-9]*/)) {

      // solves the issue ORBITEN-1317 by always deleting any cookietest cookies
      // adding it here rather than in the cookie jar regex, as it would be the only
      // negative test case in the list. Making it difficult to understand.
      return false;
    }

    policy = bbccookies.readPolicy();
    list = getAllowedList(policy);
    allowed = list.test(cookieName);

    return allowed;
  };

  /**
   * Gets the current browser/user's cookie preferences
   * @param {string} [categoryName] - the category of cookie preferences to inspect. Should be "ads",
   * "personalisation", "performance" or "necessary"
   * @returns {Object|boolean} If catgeoryName is not specified, returns a preferences object, with keys "ads",
   * "personalisation", "performance" and "necessary", with a boolean value, indicating if cookies in that category
   * can be set. If categoryName is specified, returns a boolean value directly.
   */
  bbccookies.readPolicy = function(categoryName) {
    var policy = decompilePolicyCookie();
    if (categoryName) {
      return policy[categoryName];
    } else {
      return policy;
    }
  };

  /**
   * Gets the current browser/user's cookie preferences as a string suitable for analytics reporting
   * @returns {Object|boolean} Returns a string representing the cookie preferences
   */
  bbccookies.analyticsPolicyString = function() {
    var policy = decompilePolicyCookie();
    return 'ad' + +policy.ads + 'ps' + +policy.personalisation + 'pf' + +policy.performance
  };

  /**
   * Gets the value of a cookie at a specified key. If a key is not specified, returns the contents of document.cookie
   * @returns {string}
   */
  bbccookies.get = function(key) {
    if (!key) {
      return document.cookie;
    }
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
  };

  bbccookies.isCookiePolicySet = function() {
    return bbccookies.get(bbccookies.POLICY_COOKIE_NAME) !== null;
  };

  bbccookies.setImplicitPolicy = function(region) {
    var ukDefaultPolicy = {
      ads: false,
      personalisation: false,
      performance: false,
      necessary: true
    };
    var euDefaultPolicy = {
      ads: false,
      personalisation: false,
      performance: false,
      necessary: true
    };
    var restOfTheWorldDefaultPolicy = {
      ads: true,
      personalisation: true,
      performance: true,
      necessary: true
    };

    if (region === 'gb') {
      writePolicy(ukDefaultPolicy, false);
    } else if (region === 'eu') {
      writePolicy(euDefaultPolicy, false);
    } else if(region === 'row') {
      writePolicy(restOfTheWorldDefaultPolicy, false);
    }
  };


  let prevPromise = null;
  /**
   * Sets the user/browser's cookie preferences for a specified category.
   * @param {string} categoryName - the name of the category
   * @param {boolean} preferenceValue - true for opt-in, false for opt-out
   * @private
   */
  bbccookies._setPolicy = function(categoryName, preferenceValue) {
    let policy = bbccookies.readPolicy();
    policy[categoryName] = !!preferenceValue;
    if(prevPromise === null){
      prevPromise = bbccookies.setPolicy(policy);
    }else{
      let localPrevPromise = prevPromise
      prevPromise = localPrevPromise.then(function() {
        return bbccookies.setPolicy(policy);
      });
    }
  };

  bbccookies.isCookieExplicitSet = function() {
    return bbccookies.get(bbccookies.EXPLICIT_COOKIE_NAME) !== null;
  };

  /**
   * Copy current cookie preferences across to the next domain
   */
  bbccookies.copyExplicitCookiesCrossDomain = function(done) {
      writeExplicit(bbccookies.get(bbccookies.EXPLICIT_COOKIE_NAME), true, done);
  };

  bbccookies.setCookieExplicitCrossDomain = function(explicit) {
      writeExplicit(explicit, true);
  };

  /**
   * @method bbcookies.cookiesEnabled
   * @public
   * @returns {boolean} true if the browser has cookie support, otherwise false
   */
  bbccookies.cookiesEnabled = function() {
    // taken from
    // https://github.com/Modernizr/Modernizr/blob/06c035c9e0eee214b7ba91e65a8f3a427edb895a/feature-detects/cookies.js#L16
    try {
      // Create cookie
      document.cookie = 'cookietest=1';
      var ret = document.cookie.indexOf('cookietest=') !== -1;
      // Delete cookie
      document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
      return ret;
    }
    catch (e) {
      return false;
    }
  }
  /**
   * Deletes a the cookie with a specified key.
   * @param {string} key - The name of cookie to remove
   * @param {string} [domain] - the domain from which to remove the cookie
   */
  bbccookies.delete = function(key, options) {
    key = sanitiseKey(key);
    unsanitisedDelete(key, options);
  }

  bbccookies.del = bbccookies.delete;

  //deletes a cookie without sanitising the key name
  function unsanitisedDelete(key, options) {
    if (key !== undefined) {
      //need to write using document.cookie as set won't allow us to set a cookie
      var opts = {}
      opts.expires = new Date(0);
      if (options) {
        opts.domain = options.domain;
        opts.path = options.path;
      }
      document.cookie = generateCookieString(key, "removed", opts);
    } else {
      return null;
    }
  }

  bbccookies._crunch = function() {
    //look through document.cookie for keys matching performance(initially), call delete on each one
    //do a find and replace, doesn't work
    deleteEverywhere('');
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookieParts = cookies[i].split("=");
      var keyName = cookieParts[0].trim();
      if (!this.isAllowed(keyName)) {
        deleteEverywhere(keyName);
      }
    }
  }

  bbccookies._getCurrentDomain = function() {
    try {
      var domain = window.location.hostname.toLowerCase();
      return domain.match(/.*(bbc\.co\.uk|bbc\.com)\/*/)[1];
    } catch (err) {
      return undefined;
    }
  };

  //deletes on all paths and domains as part of the crunch
  function deleteEverywhere(key) {
    var parts = window.location.hostname.split('.');
    var partsLength = parts.length;
    unsanitisedDelete(key);
    deleteOnAllPaths(key);
    while (parts.length && '|co.uk|com|'.indexOf('|' + parts.join('.') + '|') === -1) {
      if (parts.length) {
        var domain = parts.join('.');
        unsanitisedDelete(key, {
          domain: domain
        });
        deleteOnAllPaths(key, domain);
      }
      parts.shift();
    }
  }

  function deleteOnAllPaths(key, domain) {
    var paths = window.location.pathname.split('/');
    unsanitisedDelete(key, domain);
    while (paths.length) {
      var path = paths.join('/');
      if (path === '') path = '/';
      unsanitisedDelete(key, {
        domain: domain,
        path: path
      });
      if (domain) {
        unsanitisedDelete(key, {
          domain: '.' + domain,
          path: path
        });
      }
      paths.pop();
    }
  }

  function getAllowedList(policy) {
    var cacheKey = JSON.stringify(policy);
    if (typeof(policyCache[cacheKey]) !== 'undefined') {
      return policyCache[cacheKey];
    }

    var whiteList = '';

    for (var cat in policy) {
      if (policy.hasOwnProperty(cat) && bbccookies_jars[cat]) {
        if (policy[cat] === true) {
          whiteList += (whiteList ? '|' : '') + bbccookies_jars[cat];
        }
      }
    }
    policyCache[cacheKey] = new RegExp('^(' + (whiteList ? whiteList : '.*') + ')$', 'i');

    return policyCache[cacheKey];
  }

  function decompilePolicyCookie() {
    var pattern = new RegExp('(?:^|; ?)' + bbccookies.POLICY_COOKIE_NAME + '=(\\d)(\\d)(\\d)($|;)'),
      parts = document.cookie.match(pattern);

    if (parts) {
      return {
        ads: !!+parts[1],
        personalisation: !!+parts[2],
        performance: !!+parts[3],
        necessary: true
      };
    } else {
      return DEFAULTPOLICY;
    }
  }

  function nextYear() {
    var d = new Date();
    d.setYear(d.getFullYear() + 1);
    return d;
  }

  function writePolicy(policy, isCrossDomainEnabled, done) {
    var d = nextYear();
    var policyString = '' + (policy.ads ? 1 : 0) + (policy.personalisation ? 1 : 0) + (policy.performance ? 1 : 0);

    var currentDomain = bbccookies._getCurrentDomain();
    bbccookies.set(bbccookies.POLICY_COOKIE_NAME, policyString, {
      domain: currentDomain,
      path: '/',
      expires: d,
      crossDomainEnabled: isCrossDomainEnabled,
      sameSite: 'None',
      secure: onHttps
    }, done);

    // expire this cookie one month after policy cookie
    var expires = new Date(d.getTime());
    expires.setMonth(expires.getMonth() + 1);

    bbccookies.set(POLICY_EXPIRY_COOKIENAME, d.getTime(), {
      domain: currentDomain,
      path: '/',
      expires: expires,
      sameSite: 'None',
      secure: onHttps
    });

    return policy;
  }

  function writeExplicit(explicit, isCrossDomainEnabled, done) {
    var d = nextYear();
    var explicitString = '' + explicit;

    var currentDomain = bbccookies._getCurrentDomain();
    bbccookies.set(bbccookies.EXPLICIT_COOKIE_NAME, explicitString, {
      domain: currentDomain,
      path: '/',
      expires: d,
      crossDomainEnabled: isCrossDomainEnabled,
      sameSite: 'None',
      secure: onHttps
    }, done);

    return explicit;
  }

  function getCookieName(cookieString) {
    var matches = ('' + cookieString).match(/^([^=]+)(?==)/); //(^_^)//

    return (matches && matches.length ? matches[0] : '');
  }

  function sanitiseKey(key) {
    key = key.replace(/[^#$&+\^`|]/g, encodeURIComponent);
    key = key.replace(/\(/g, '%28').replace(/\)/g, '%29');
    return key;
  }

  function generateCookieString(key, value, options) {
    var theDomain = (options && options.domain) ? ';domain=' + options.domain : '';
    value = (value + '').replace(/[^!#$&-+\--:<-\[\]-~]/g, encodeURIComponent);
    options = options || {};

    var cookieString = key + '=' + value;
    cookieString += options.path ? ';path=' + options.path : '';
    cookieString += options.domain ? ';domain=' + options.domain : '';
    cookieString += options.expires ? ';expires=' + options.expires.toUTCString() : '';
    cookieString += ';sameSite=' + options.sameSite || 'None';
    cookieString += options.secure || onHttps ? ';secure' : '';
    return cookieString;
  }

  /*!
   * contentloaded.js
   *
   * Author: Diego Perini (diego.perini at gmail.com)
   * Summary: cross-browser wrapper for DOMContentLoaded
   * Updated: 20101020
   * License: MIT
   * Version: 1.2
   *
   * URL:
   * http://javascript.nwbox.com/ContentLoaded/
   * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
   *
   */

  // @win window reference
  // @fn function reference
  function contentLoaded(win, fn) {

    var done = false,
      top = true,

      doc = win.document,
      root = doc.documentElement,
      modern = doc.addEventListener,

      add = modern ? 'addEventListener' : 'attachEvent',
      rem = modern ? 'removeEventListener' : 'detachEvent',
      pre = modern ? '' : 'on',

      init = function(e) {
        if (e.type === 'readystatechange' && doc.readyState != 'complete') return;
        (e.type === 'load' ? win : doc)[rem](pre + e.type, init, false);
        if (!done && (done = true)) fn.call(win, e.type || e);
      },

      poll = function() {
        try {
          root.doScroll('left');
        } catch (e) {
          setTimeout(poll, 50);
          return;
        }
        init('poll');
      };

    if (doc.readyState === 'complete') fn.call(win, 'lazy');
    else {
      if (!modern && root.doScroll) {
        try {
          top = !win.frameElement;
        } catch (e) {}
        if (top) poll();
      }
      doc[add](pre + 'DOMContentLoaded', init, false);
      doc[add](pre + 'readystatechange', init, false);
      win[add](pre + 'load', init, false);
    }

  }

  //this public method is deprecated but is used by the cookies settings page.
  bbccookies._getPolicy = bbccookies.readPolicy;

  contentLoaded(window, function() {
    bbccookies._crunch()
  });
  if (window.addEventListener) {
    window.addEventListener('beforeunload', function() {
      bbccookies._crunch()
    }, false);
  } else if (window.attachEvent) {
    window.attachEvent('onbeforeunload', function() {
      bbccookies._crunch();
    });
  } else {
    window.onbeforeunload = function() {
      bbccookies._crunch();
    };
  }

export default bbccookies;
